// DayPasses reducer

import { API_STATUS } from '../../../utilities/constants';
import { initializeState } from '../../../utilities/storageUtils';
import dayPassActionTypes from './dayPasses.types';

const INITIAL_STATE = {
  numberOfGuests: 0,
  arrivalDate: null,
  departureDate: null,
  selectedTitle: '',
  selectedRate: 0,
  selectedRateCode: '',
  selectedItemCode: '',
  selectedDescription: '',
  availabilityKey: null,
  promoCode: '',
  qualifyingId: '',
  item: {
    rate: '',
    itemCode: '',
    rateCode: ''
  },
  seasonInfo: null,
  promoCodeData: null,
  seasonPassInfoApiStatus: API_STATUS.IDLE,
  seasonPassChargesApiStatus: API_STATUS.IDLE,
  parkingFee: 0,
  resortFee: 0,
  sustainabilityFee: 0,
  taxesAndFees: 0,
  passType: null,
  total: 0
};

const dayPassesReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  switch (action.type) {
    case dayPassActionTypes.SET_DAYPASSES:
      return {
        ...state,
        availabilityKey: action.availabilityKey,
        arrivalDate: action.arrivalDate,
        numberOfGuests: action.numberOfGuests,
        selectedTitle: action.selectedTitle,
        selectedRate: action.selectedRate,
        selectedItemCode: action.selectedItemCode,
        selectedRateCode: action.selectedRateCode,
        promoCode: action.promoCode,
        qualifyingId: action.qualifyingId,
        selectedDescription: action.selectedDescription,
        parkingFee: action.parkingFee,
        resortFee: action.resortFee,
        sustainabilityFee: action.sustainabilityFee,
        taxesAndFees: action.totalTaxesAndFees,
        item: [action.item]
      };
    case dayPassActionTypes.GET_SEASON_PASS_INFO_SUCCESS:
      return {
        ...state,
        seasonInfo: action.seasonInfo || null,
        seasonPassInfoApiStatus: API_STATUS.SUCCEEDED
      };
    case dayPassActionTypes.GET_SEASON_PASS_INFO_LOADING:
      return {
        ...state,
        seasonPassInfoApiStatus: API_STATUS.LOADING
      };
    case dayPassActionTypes.GET_SEASON_PASS_INFO_ERROR:
      return {
        ...state,
        seasonPassInfoApiStatus: API_STATUS.ERROR
      };
    case dayPassActionTypes.GET_SEASON_PASS_CHARGES_LOADING:
      return {
        ...state,
        seasonPassChargesApiStatus: API_STATUS.LOADING
      };
    case dayPassActionTypes.GET_SEASON_PASS_CHARGES_SUCCESS:
      return {
        ...state,
        seasonPassChargesApiStatus: API_STATUS.SUCCEEDED,
        arrivalDate: action.arrivalDate,
        numberOfGuests: action.numberOfGuests,
        departureDate: action.departureDate,
        selectedTitle: action.selectedTitle,
        selectedDescription: action.selectedDescription,
        selectedRate: action.selectedRate,
        selectedItemCode: action.selectedItemCode,
        passType: action.passType,
        availabilityKey: action.availabilityKey,
        taxesAndFees: action.charges?.totalTaxesAndFees,
        resortFee: action.charges?.resortFee,
        total: action.charges?.total
      };
    case dayPassActionTypes.GET_SEASON_PASS_CHARGES_ERROR:
      return {
        ...state,
        seasonPassChargesApiStatus: API_STATUS.ERROR
      };
    case dayPassActionTypes.CLEAR_DAYPASSES:
      return INITIAL_STATE;
    default:
  }

  return state;
};

export default dayPassesReducer;
